var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formConfig
    ? _c(
        "div",
        {
          staticClass: "item-template",
          class:
            ((_obj = { active: _vm.isActivated }),
            (_obj[_vm.formType] = true),
            _obj),
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.onActive.apply(null, arguments)
            }
          }
        },
        [
          _c(_vm.formType && "form-item-" + _vm.formType, {
            tag: "component",
            attrs: { formNode: _vm.formNode }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "custom-wrap" }, [
            _vm._v(_vm._s(_vm.customName))
          ]),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: ["grid", "free"].includes(_vm.formType) == false,
                expression: "['grid', 'free'].includes(formType) == false"
              }
            ],
            staticClass: "mark-wrap"
          }),
          _vm._v(" "),
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActivated,
                expression: "isActivated"
              }
            ],
            staticClass: "drag-bar iconfont iconmove"
          }),
          _vm._v(" "),
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActivated,
                expression: "isActivated"
              }
            ],
            staticClass: "copy-bar iconfont iconcopy",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.onCopy.apply(null, arguments)
              }
            }
          }),
          _vm._v(" "),
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActivated,
                expression: "isActivated"
              }
            ],
            staticClass: "delete-bar iconfont icondelete",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.onDelete.apply(null, arguments)
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fdaa1fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fdaa1fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form_item/FormItemTemplate.vue
// module id = null
// module chunks = 